module.exports = __webpack_public_path__ + "img/Ellipse-moyenne.0f206c54.png";